document.addEventListener("DOMContentLoaded", function() {

    if(document.querySelector('.product .product__media-item')) {
      fetch('https://ipapi.co/json/')
        .then(response => response.json())
        .then(data => {
          const countryCode = data.country_code;
          const countryName = data.country_name;

          if(document.getElementById('shipping-message')) {
            if(document.getElementById('shipping-message').getAttribute('data-shipping-text')) {
              var shippingMessage = document.getElementById('shipping-message').getAttribute('data-shipping-text') + " <b><u>" + countryName+'</u></b>';
            } else {
              var shippingMessage = "Free Shipping to <b><u>" + countryName+'</u></b>';
            }
        
  
         
            const flag = getFlagEmoji(countryCode);
    
            // Display the message
            const messageElement = document.getElementById('shipping-message');
            messageElement.innerHTML = `${flag} ${countryCode} | ${shippingMessage}`;
          }
        })
        .catch(error => console.error('Error fetching the geolocation data:', error));
  
      function getFlagEmoji(countryCode) {
        const codePoints = countryCode
          .toUpperCase()
          .split('')
          .map(char => 127397 + char.charCodeAt());
        return String.fromCodePoint(...codePoints);
      }
    }

  if(document.querySelectorAll('.collapsible-content__header').length && document.querySelectorAll('.product').length) { 
    if(locale != 'en') { 
      document.querySelectorAll('.collapsible-content__header')[0].innerHTML += '<div class="quick-contact"><a href="/'+locale+'/pages/contact" class="button-base">'+textButtonContact+'</div>';
    } else {
      document.querySelectorAll('.collapsible-content__header')[0].innerHTML += '<div class="quick-contact"><a href="/pages/contact" class="button-base">'+textButtonContact+'</div>';
    }
  }

  sourceRewards();
});

function sourceRewards() {
  const sourceRewards = document.querySelector('cart-drawer-items .rewards');
  const productRewards = document.querySelectorAll('.product-rewards');
  const productRewardsBlock = document.querySelectorAll('.product-rewards-block');

  if (sourceRewards && productRewards.length) {
    const rewardsHTML = sourceRewards.innerHTML;
    productRewards.forEach(el => {
      el.innerHTML = rewardsHTML; 
      //el.querySelector('.rewards-unlock-text h3').innerHTML = 'BUY MORE & SAVE UP TO 20%!<div class="free-gift-timer">Ends in <span class="gift-timer">00:00:00</span></div></div>';
      el.querySelector('.rewards-unlock-text h3').innerHTML = 'BUY MORE & SAVE UP TO 20%!<div class="free-gift-special">EXTRA SAVINGS</div></div>';
      updateGiftTimer();
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {

  
  
  if(document.querySelector('[data-modal-close]')) {
    document.querySelectorAll('[data-modal-close]').forEach(function(element){
      element.addEventListener('click', function(e) {  
        document.getElementById(element.getAttribute('data-modal-close')).click();
      });
    });
  }
  
  document.querySelectorAll('.fixed-option-select').forEach(function(selectElement){
    if (selectElement) { 
      selectElement.addEventListener('change', function(e) { 
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        if(document.querySelectorAll(`.product label[data-${selectedOption.getAttribute('data-attr')}="${selectedOption.value}"]`).length) {
          document.querySelectorAll(`.product label[data-${selectedOption.getAttribute('data-attr')}="${selectedOption.value}"]`)[0].previousElementSibling.click()
        }        
      });
    }
  });  
  
  if(document.querySelectorAll('.product variant-selects input[type="radio"]').length) {
    const radios = document.querySelectorAll('.product variant-selects input[type="radio"]');
    
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const selectedValue = radio.value;  // Get the selected value
        const selectedName = radio.getAttribute('name').toLowerCase();  // Get the associated name
        if(document.querySelector('#fixed-add-to-cart .item[data-attr="'+selectedName+'"] select')) {
          document.querySelector('#fixed-add-to-cart .item[data-attr="'+selectedName+'"] select').value = selectedValue;
        }        
      });
    });
  }
  
  if(document.getElementById('fixed-action-add-to-cart')) {
    document.getElementById('fixed-action-add-to-cart').addEventListener('click', function() {
      if (!document.getElementById('fixed-action-add-to-cart').disabled && document.querySelector('form[action*="/cart/add"] [name="add"]')) {
        
        document.querySelector('form[action*="/cart/add"] [name="add"]').click();
        if (!document.querySelector('#fixed-action-add-to-cart .pre-loading')) {
                // Create a new div element with the spinner
                var spinnerDiv = document.createElement('div');
                spinnerDiv.className = 'pre-loading';
                spinnerDiv.innerHTML = `
                    <div class="loading__spinner">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                `;
                
                // Append the new div to the button
                document.getElementById('fixed-action-add-to-cart').appendChild(spinnerDiv);
            }
        
      }
    });
  }

  


  const addCartBtn = document.getElementById('fixed-add-to-cart');
  const addButtonBig = document.querySelector('form[action*="/cart/add"] [name="add"]');

  // Function to check if the element is in the viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 && // Element is above the top of the viewport
      rect.left >= 0 && // Element is to the right of the left of the viewport
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // Element is below the bottom of the viewport
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) // Element is to the left of the right of the viewport
    );
  }

  // Function to toggle class 'show' on add-cart-btn
  function toggleAddCartButton() {
    const isScrolledNearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - document.querySelectorAll('.footer')[0].offsetHeight);
    const isScrolledMoreThanThreshold = window.scrollY > 60; // Check if scrolled more than the threshold

    if (addButtonBig && isElementInViewport(addButtonBig)) {
        addCartBtn.classList.remove('show'); // Remove 'show' if add-button-big is visible
        document.querySelector('body').removeAttribute('data-add-to-cart-active');
    } else if (!isScrolledNearBottom && isScrolledMoreThanThreshold) {
        addCartBtn.classList.add('show'); // Add 'show' if add-button-big is not visible, not scrolled near bottom, and scrolled more than threshold
        document.querySelector('body').setAttribute('data-add-to-cart-active', 'true');
    } else {
        addCartBtn.classList.remove('show'); // Remove 'show' if scrolled near the bottom or not scrolled more than threshold
        document.querySelector('body').removeAttribute('data-add-to-cart-active');
    }
  }
  
  if(addCartBtn) {
    toggleAddCartButton();
  }

  // Add scroll event listener
  window.addEventListener('scroll', function() {
    if(addCartBtn) {
      toggleAddCartButton();
    }
  });

  // Optional: Also check when the window is resized
  window.addEventListener('resize', function() {
    if(addCartBtn) {
      toggleAddCartButton();
    }
  });

});


function initWheelCart() {
  const container = document.querySelector('.cart-recommendations .overflow-container');

  container.addEventListener('wheel', function(event) {
    console.log(event);
    if (event.deltaY !== 0) {
      container.scrollLeft += event.deltaY; // Adjust this value to control scroll speed
      event.preventDefault(); // Prevent default vertical scroll
    }
  });
}


document.addEventListener('DOMContentLoaded', function() {
  const mediaWrapper = document.querySelector('.product__media-wrapper media-gallery');
  const productInfo = document.querySelector('.product__info-wrapper');

  if (!mediaWrapper || !productInfo) {
    return; // Exit if elements do not exist
  }

  const mediaWrapperHeight = mediaWrapper.offsetHeight; // Height of the media wrapper

  // Function to manage scrolling behavior
  function handleScroll() {
    const scrollY = window.scrollY;

    if (scrollY > mediaWrapperHeight) {
      // While the user is within the height of the media wrapper
      mediaWrapper.style.position = 'relative'; // Keep it relatively positioned
      mediaWrapper.style.marginBottom = '0';
    } else {
      // When scrolled past the height of the media wrapper
      mediaWrapper.style.position = 'sticky'; // Make it fixed
      mediaWrapper.style.top = '0';
      mediaWrapper.style.marginBottom = `${-scrollY}px`; // Use negative margin for overlapping effect
    }
  }

  // Check on scroll
  //window.addEventListener('scroll', handleScroll);

  // Initial check when the document is loaded
  //handleScroll();
});

function openTab(evt, tabName, element) {

    if (evt.currentTarget.classList.contains("tab-buttons-active")) {
      return;
    }
    
    var i, tab, tabButtons;
    var tabContainer = element.closest('.tab-container');

    tab = tabContainer.getElementsByClassName("tab");
    for (i = 0; i < tab.length; i++) {
      tab[i].classList.remove("tab-active");
    }

    tabButtons = tabContainer.getElementsByClassName("tab-buttons");
    for (i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("tab-buttons-active");
    }

    tabContainer.querySelector(`#${tabName}`).classList.add("tab-active");
    evt.currentTarget.classList.add("tab-buttons-active");
  }

function openTabSimple(evt, tabName) {
    // Get all tab content elements and hide them
    var tabs = document.getElementsByClassName('main-tab');
    for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('active');
    }
 
    var tabButtons = document.getElementsByClassName('main-tab-button');
    for (var i = 0; i < tabButtons.length; i++) {
        tabButtons[i].classList.remove('active');
    }
 
    document.getElementById(tabName).classList.add('active');
    evt.currentTarget.classList.add('active');
}

function scrollToElement(elem) {  
  var elmnt = document.getElementById(elem);
  elmnt.scrollIntoView({ behavior:'smooth', block:'start' });
}

function scrollToReviews() {
  if(document.querySelector('.oke-w-main')) {
    var elmnt = document.querySelector('[data-oke-widget]');
    var topOffset = elmnt.getBoundingClientRect().top + window.pageYOffset - 110;  
  } else if (document.querySelector('.customer-reviews')) {
    var elmnt = document.querySelector('.customer-reviews');
    var topOffset = elmnt.getBoundingClientRect().top + window.pageYOffset+1;  
  }  else if (document.querySelector('.fair-reviews')) {
    var elmnt = document.querySelector('.fair-reviews');
    var topOffset = elmnt.getBoundingClientRect().top + window.pageYOffset+1;  
  } else {
    return;
  }
  window.scrollTo({
    top: topOffset,
    behavior: 'smooth'
  });
}

function scrollToReviewsFair() {
  if (document.querySelector('.fair-reviews')) {
    var elmnt = document.querySelector('.fair-reviews');
    var topOffset = elmnt.getBoundingClientRect().top + window.pageYOffset+1;  
  } else {
    return;
  }
  window.scrollTo({
    top: topOffset,
    behavior: 'smooth'
  });
}

 
function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
 
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
 
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
 


  // Define globally accessible function
window.initializeObserver = function() {
  if (window.globalObserver) {
    window.globalObserver.disconnect(); // Clean up previous observer if it exists
  }

  let scrollLink = document.querySelector('.pagination-next');
  
  if ('IntersectionObserver' in window) {
    window.globalObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const url = scrollLink ? scrollLink.getAttribute('href') : '';
          loadContent(url);
        }
      });
    }, {
      root: null, // Use viewport
      rootMargin: '400px', // Trigger before actually reaching the element
      threshold: 0
    });

    const paginationLoader = document.querySelector('.pagination-loader');
    if (paginationLoader) {
      window.globalObserver.observe(paginationLoader);
    }
  } else {
    // Fallback to scroll event for older browsers
    function scrollExecute() {
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollTop = window.scrollY;
      const threshold = 400;

      if (documentHeight - threshold < (scrollTop + windowHeight)) {
        const url = scrollLink ? scrollLink.getAttribute('href') : '';
        loadContent(url);
      }
    }

    function debounce(fn, delay) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
      };
    }

    window.addEventListener('scroll', debounce(scrollExecute, 200), { passive: true });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  const productList = document.getElementById('product-grid');
  let scrollLink = document.querySelector('.pagination-next');

  // Delegate click event to dynamically loaded button
  document.addEventListener('click', function(event) {
    if (event.target && event.target.id === 'load-more-button') {
      scrollLink = document.querySelector('.pagination-next');
      const url = scrollLink ? scrollLink.getAttribute('href') : '';
      loadContent(url);
    }
  });
  
  // Initialize the observer or scroll handler only if the elements exist
  if (scrollLink) {
    window.initializeObserver();
  } else {
    console.warn('Pagination link is missing.');
  }
});

var isLoading = false; // Flag to prevent multiple loads

function loadContent(url) {
  if (!url || isLoading) return; // Exit if a load is already in progress

  // Set the flag to true to indicate loading has started
  isLoading = true;

  // Ensure the URL is always up-to-date
  scrollLink = document.querySelector('.pagination-next');
  if (scrollLink) {
    url = scrollLink.getAttribute('href');
  } else {
    console.warn('Pagination link is missing.');
    isLoading = false; // Reset flag
    return;
  }

  console.log('Fetching content from URL:', url);

  const paginationLoader = document.querySelector('.pagination-loader');
  if (paginationLoader) {
    paginationLoader.classList.remove('prestate');
  }

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const filteredData = doc.querySelectorAll('#product-grid .grid__item');
      const paginationNext = doc.querySelector('.pagination-next');
      const productList = document.getElementById('product-grid');

      // Create a DocumentFragment to minimize reflows
      const fragment = document.createDocumentFragment();
      filteredData.forEach(product => {
        fragment.appendChild(document.importNode(product, true)); // Import node into the current document
      });

      productList.appendChild(fragment);

      // Update pagination link and state
      if (paginationNext) {
        scrollLink.setAttribute('href', paginationNext.getAttribute('href'));
        if (paginationLoader) {
          paginationLoader.style.display = 'block';
          paginationLoader.classList.add('prestate');
          // Re-initialize IntersectionObserver
          //window.initializeObserver();
        }
      } else if (paginationLoader) {
        scrollLink.remove();
        paginationLoader.style.display = 'none';
      }

      initializeSliders(true);
      initializeSwatches();

      // Reset the flag after content has been loaded
      isLoading = false;
    })
    .catch(error => {
      console.error('Fetch error:', error);
      // Reset the flag if there is an error
      isLoading = false;
    });
}


document.addEventListener('DOMContentLoaded', function() {
  var showMoreButton = document.querySelector('[data-custom-reviews-show-more]');
  
  if (showMoreButton) { 
    // Define how many reviews to show per click
    var reviewsPerClick = 5;
    
    // Function to show more reviews
    function showMoreReviews() {
      // Show the spinner
      var spinner = showMoreButton.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }

      // Fake loading time
      setTimeout(function() {
        // Select all hidden reviews
        var hiddenReviews = document.querySelectorAll('.customer-review[style*="display: none;"]');
        
        // Determine the number of reviews to show
        var reviewsToShow = Array.from(hiddenReviews).slice(0, reviewsPerClick);
        
        // Show the reviews
        reviewsToShow.forEach(function(review) {
          review.style.display = 'block';
        });

        // Hide the spinner
        if (spinner) {
          spinner.classList.add('hidden');
        }

        // If there are no more hidden reviews, hide the "Show More" button
        if (hiddenReviews.length <= reviewsPerClick) {
          showMoreButton.style.display = 'none';
        }
      }, 2000);
    }

    // Add click event listener to the button
    showMoreButton.addEventListener('click', function() { 
      showMoreReviews();
    });
  }
});

function handleLikeDislikeClick(event, type) {
        event.preventDefault();

        const button = event.currentTarget;
        const isClicked = button.classList.contains('clicked');
        const increment = isClicked ? -1 : 1;

        // Update the count
        const countElement = button.querySelector('.count');
        let count = parseInt(countElement.textContent.trim(), 10);
        count += increment;
        countElement.textContent = count;

        // Toggle bold styling and clicked state
        button.classList.toggle('bold');
        button.classList.toggle('clicked');
    }
/*
const initializedSliders = new Set();

function initializeSliders(isExistCheck = true) {

  const sliders = document.querySelectorAll('.swiper-container');

  sliders.forEach((slider) => {
    const sliderId = slider.getAttribute('data-slider-id');

    // Skip initialization if already done
    if(isExistCheck) {
      if (initializedSliders.has(sliderId)) return;
    }

    // Mark this slider as initialized
    initializedSliders.add(sliderId);

    // Initialize SwiperJS
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });
  });
}

// Initialize sliders on page load
document.addEventListener('DOMContentLoaded', initializeSliders);
*/

const sliderInstances = new Map();

  /**
   * Actually initialize a single slider if not already done.
   */
  function initSlider(sliderEl) {
    if (sliderInstances.has(sliderEl)) {
      // Already initialized, skip
      return;
    }

    const mySwiper = new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      //Scroll with touchpad
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange: function () {
          if(this.activeIndex == 0) {
            return;
          }
          const slide = this.slides[this.activeIndex];
          if (!slide) return;

          const placeholder = slide.querySelector('[data-img-lazy]');
          if (!placeholder) return;

          const loader = slide.querySelector('.loader-swatches');
          if (loader) loader.classList.add('active');

          const img = document.createElement('img');
          img.src = placeholder.getAttribute('data-img-lazy');
          img.alt = placeholder.getAttribute('data-alt') || '';

          img.onload = function() {
            if (loader) setTimeout(() => loader.classList.remove('active'), 200);
          };
          img.onerror = function() {
            if (loader) loader.classList.remove('active');
          };

          placeholder.replaceWith(img);
        }
      }
    });

    // Store reference so we don't re-init this element
    sliderInstances.set(sliderEl, mySwiper);
  }

  /**
   * Sets up lazy initialization of all .swiper-container elements
   * using IntersectionObserver.
   */
  function initializeSliders() {
    
    const lazySliders = document.querySelectorAll('.swiper-container');

    // For browsers that support IntersectionObserver
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Initialize slider once it's on screen
              initSlider(entry.target);
              // Stop observing so we don’t re-init the same slider
              obs.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '0px', // or something like '100px'
          threshold: 0.1,    // how much should be visible before init
        }
      );

      lazySliders.forEach((sliderEl) => {
        observer.observe(sliderEl);
      });
    } else {
      // Fallback: initialize all sliders immediately if IntersectionObserver is not available
      lazySliders.forEach((sliderEl) => {
        initSlider(sliderEl);
      });
    }
  }

// Call this on DOMContentLoaded or after AJAX appends new sliders
document.addEventListener('DOMContentLoaded', () => {
  initializeSliders();
});


function onClickHref(event, element) {
  // Check if the Ctrl or Cmd key is held
  const isNewTab = event.ctrlKey || event.metaKey;

  // Proceed with click action
  const targetId = element.getAttribute('data-target-id');
  if (targetId) {
    const targetElement = document.querySelector(targetId);
    if (targetElement && targetElement.href) {
      if (isNewTab) {
        // Open the link in a new tab if Ctrl or Cmd is pressed
        window.open(targetElement.href, '_blank');
      } else {
        // Regular click behavior, navigate to the link
        targetElement.click();
      }
    }
  }
}

// Function to update the countdown for each element
function startCountdown(element) {
  // Get the current date and time
  const now = new Date();
  
  // Calculate the next midnight (after adding one day)
  const nextMidnight = new Date(now);
  nextMidnight.setDate(now.getDate() + 1); // Move to the next day
  nextMidnight.setHours(24, 0, 0, 0); // Set to 00:00 of the next day
  
  // Function to update the countdown every second
  function updateCountdown() {
    const now = new Date();
    const remainingTime = nextMidnight - now; // Time remaining until the next midnight plus one day
    
    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    
    // Format the countdown string with correct singular/plural for days
    const dayText = days === 1 ? 'day' : 'days';
    const countdownString = `${days} ${dayText} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    
    // Update the countdown display
    element.innerText = countdownString;
    element.style.display = 'block';

    // If the countdown reaches 0, reset to the next midnight plus one day
    if (remainingTime <= 0) {
      nextMidnight.setDate(nextMidnight.getDate() + 1); // Move to the next day after the countdown finishes
    }
  }

  // Call the function immediately to show the countdown right away
  updateCountdown();
  
  // Update the countdown every second
  setInterval(updateCountdown, 1000);
}

if(document.querySelector('.swiper-features')) {
    new Swiper('.swiper-features', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      grabCursor: true,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.swiper-features-button-next',
        prevEl: '.swiper-features-button-prev',
      },
      breakpoints: {
        960: {
          centeredSlides: true,
          spaceBetween: 40,          
          slidesPerGroup: 1,
        },
        1600: {
          slidesPerGroup: 1,
          centeredSlides: true,
          spaceBetween: 40
        }
      }
    });
}

if(document.querySelector('.swiper-custom-photos')) {
    new Swiper('.swiper-custom-photos', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      grabCursor: true,
      slidesPerGroup: 1,
      loop: true,
      navigation: {
        nextEl: '.swiper-custom-photos-button-next',
        prevEl: '.swiper-custom-photos-button-prev',
      },
      breakpoints: {
        960: {
          spaceBetween: 40
        }
      }
    });
}

if(document.querySelector('.swiper-custom-collections')) {
    new Swiper('.swiper-custom-collections', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      grabCursor: true,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.swiper-collections-button-next',
        prevEl: '.swiper-collections-button-prev',
      },
      breakpoints: {
        960: {
          centeredSlides: true,
          spaceBetween: 40,          
          slidesPerGroup: 1,
        },
        1600: {
          slidesPerGroup: 1,
          centeredSlides: true,
          spaceBetween: 40
        }
      }
    });
}

if(document.querySelector('.swiper-swatch-slider')) {
    new Swiper('.swiper-swatch-slider', {
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 0,
      freeMode: true,
      grabCursor: true,
      slidesPerGroup: 3,
      navigation: {
        nextEl: '.swiper-swatch-slider-button-next',
        prevEl: '.swiper-swatch-slider-button-prev',
      }
    });
}

  
if(document.querySelector('.cart-slides')) {
    initCartSlides();
    function initCartSlides() {
      new Swiper('.cart-slides', {
        slidesPerView: '1',
        centeredSlides: true,
        spaceBetween: 30,
        freeMode: false,
        grabCursor: true,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000
        },
        navigation: {
          nextEl: '.cart-slides-button-next',
          prevEl: '.cart-slides-button-prev',
        }
      });
    }
  }



if(document.querySelector('.special-countdown')) {
  // Find all elements with the 'special-countdown' class and start a countdown for each
  const countdownElements = document.querySelectorAll('.special-countdown');
  countdownElements.forEach(startCountdown);
}

function saveRecentlyViewed(productHandle) {
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

    // Remove the product if it's already in the list
    recentlyViewed = recentlyViewed.filter(handle => handle !== productHandle);

    // Add the new product at the beginning
    recentlyViewed.unshift(productHandle);

    // Keep only the last 10 viewed products
    if (recentlyViewed.length > 9) {
      recentlyViewed.pop();
    }
    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
  }


function updateGiftTimer() {
  // Use class instead of ID for multiple elements
  const timers = document.querySelectorAll('.gift-timer');
  
  if (timers.length === 0) {
    return;
  }

  const endTime = new Date();
  endTime.setHours(23, 59, 59, 999); // today at 11:59 PM
  const now = new Date();
  const diff = endTime - now;

  let timeText;
  if (diff <= 0) {
    timeText = "00:00:00";
  } else {
    const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    timeText = `${h}:${m}:${s}`;
  }

  // Update all timer elements
  timers.forEach(timer => {
    timer.textContent = timeText;
  });

  // Continue animation if time remaining
  if (diff > 0) {
    requestAnimationFrame(updateGiftTimer);
  }
}

document.addEventListener("DOMContentLoaded", updateGiftTimer);


document.addEventListener("DOMContentLoaded", function() {
  initializeSwatches();
});


function initializeSwatches() {
  const swatchElements = document.querySelectorAll('[data-swatch-id]:not([data-swatch-initialized])');

  if (swatchElements.length > 0) {
    // Attach wheel listeners to all swatch containers that don't have one yet
    document.querySelectorAll('.product_tile_color_holder .list:not([data-wheel-initialized])').forEach(function(container) {
      container.setAttribute('data-wheel-initialized', 'true');
      container.addEventListener('wheel', function(event) {
        if (event.deltaY !== 0) {
          container.scrollLeft += event.deltaY;
          event.preventDefault();
        }
      });
    });

    swatchElements.forEach(function(item) {
      item.setAttribute('data-swatch-initialized', 'true');
      item.addEventListener('click', function() {
        if (!this.classList.contains('active')) {
          const parentElement = this.parentElement;
          parentElement.querySelectorAll('span').forEach(function(input) {
            input.classList.remove('active');
          });

          const swatchId = this.getAttribute('data-swatch-id');
          const variantId = this.getAttribute('data-variant-id');
          const swatchImage = this.getAttribute('data-swatch-image');
          const swatchUrl = this.getAttribute('data-swatch-url');

          document.querySelectorAll('[data-swatch-target-link-id="'+swatchId+'"]').forEach(function(link) {
            link.href = swatchUrl;
          });

          const cardWrapper = this.closest('.card-wrapper');
          const mediaElement = cardWrapper ? cardWrapper.querySelector('[data-swatch-target-media-id="'+swatchId+'"]') : null;
          const imgElement = mediaElement ? mediaElement.querySelector('.swiper-slide-active img') : null;
          const loader = mediaElement ? mediaElement.querySelector('.swiper-slide-active .loader-swatches') : null;
          const quickAddButton = cardWrapper ? cardWrapper.querySelector('.quick-add__submit') : null;

          if(quickAddButton) {
            quickAddButton.setAttribute('data-product-url', quickAddButton.getAttribute('data-product-url').split('?')[0]+'?variant='+variantId);
          }

          if (loader) {
            loader.classList.add('active');
          }

          if (imgElement) {
            const newImage = new Image();
            newImage.src = swatchImage;

            newImage.onload = function() {
              imgElement.src = swatchImage;
              imgElement.srcset = swatchImage;

              if (loader) {
                setTimeout(() => {
                  loader.classList.remove('active');
                }, 200);
              }
            };
          }

          this.classList.add('active');
        }
      });
    });
  }
}

//dropdown hover menu
document.querySelectorAll('header :not(header-drawer) .mega-menu').forEach(megaMenu => {
  megaMenu.addEventListener('mouseenter', () => {
    megaMenu.setAttribute('open', '');
  });
  megaMenu.addEventListener('mouseleave', () => {
    megaMenu.removeAttribute('open');
  });
  megaMenu.querySelector('summary').addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
  });
});

/* ============================================================
   APPLE-STYLE SWIPE-DOWN-TO-DISMISS — QUICK-ADD MODAL (MOBILE)
   ============================================================
   Overrides the default ModalDialog touch handlers with a smooth
   drag-to-dismiss gesture that translates the entire sheet.
   Only active on screens < 750px.
   ============================================================ */
(function() {
  if (typeof MutationObserver === 'undefined') return;

  const CLOSE_THRESHOLD = 130;
  const VELOCITY_THRESHOLD = 0.4;
  const BACKDROP_BASE_OPACITY = 0.7;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function setupAppleSwipe(modal) {
    if (modal._appleSwipeActive) return;
    modal._appleSwipeActive = true;

    const content = modal.querySelector('.quick-add-modal__content');
    if (!content) return;

    let scrollContainer = null;
    let startY = 0;
    let startTime = 0;
    let currentDeltaY = 0;
    let isDragging = false;
    let dragLocked = false;

    // Remove original ModalDialog touch handlers
    modal.removeEventListener('touchstart', modal.handleTouchStart);
    modal.removeEventListener('touchmove', modal.handleTouchMove);
    modal.removeEventListener('touchend', modal.handleTouchEnd);
    modal.removeEventListener('touchcancel', modal.handleTouchEnd);

    // Override hide() for animated close (X button, backdrop, Escape)
    if (!modal._originalHide) {
      modal._originalHide = modal.hide.bind(modal);
      modal.hide = function(preventFocus) {
        if (modal._swipeClosing) {
          modal._swipeClosing = false;
          return modal._originalHide(preventFocus);
        }

        if (!isMobile()) {
          // DESKTOP: slide drawer out to the right, then remove [open]
          content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down');
          content.classList.add('is-closing-back');
          modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0)', 'important');

          function onDesktopCloseDone() {
            content.removeEventListener('transitionend', onDesktopCloseDone);
            content.classList.remove('is-closing-back');
            content.style.removeProperty('transform');
            modal.style.removeProperty('background-color');
            modal._originalHide(preventFocus);
          }
          content.addEventListener('transitionend', onDesktopCloseDone);

          // Safety fallback
          setTimeout(function() {
            if (modal.hasAttribute('open')) {
              content.classList.remove('is-closing-back');
              content.style.removeProperty('transform');
              modal.style.removeProperty('background-color');
              modal._originalHide(preventFocus);
            }
          }, 300);
          return;
        }

        // MOBILE: animate close — slide content back down + fade backdrop
        content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down');
        content.classList.add('is-closing-back');
        modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0)', 'important');

        function onCloseDone() {
          content.removeEventListener('transitionend', onCloseDone);
          content.classList.remove('is-closing-back');
          content.style.removeProperty('transform');
          content.style.removeProperty('opacity');
          modal.style.removeProperty('background-color');
          modal._originalHide(preventFocus);
        }
        content.addEventListener('transitionend', onCloseDone);

        // Safety fallback
        setTimeout(function() {
          if (modal.hasAttribute('open')) {
            content.classList.remove('is-closing-back');
            content.style.removeProperty('transform');
            content.style.removeProperty('opacity');
            modal.style.removeProperty('background-color');
            modal._originalHide(preventFocus);
          }
        }, 450);
      };
    }

    function dampen(distance) {
      const h = window.innerHeight;
      return distance * (1 - distance / (distance + h * 1.2));
    }

    function updateBackdrop(distance) {
      var progress = Math.min(distance / (window.innerHeight * 0.5), 1);
      var opacity = BACKDROP_BASE_OPACITY * (1 - progress * 0.7);
      modal.style.setProperty('background-color', 'rgba(0, 0, 0, ' + opacity + ')', 'important');
    }

    function resetVisuals() {
      content.style.removeProperty('transform');
      content.style.removeProperty('opacity');
      modal.style.removeProperty('background-color');
      content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down', 'is-closing-back');
      modal.classList.remove('is-backdrop-fading');
    }

    function onTouchStart(e) {
      if (!isMobile()) return;
      scrollContainer = modal.querySelector('.quick-add-modal__content-info .page-width')
        || modal.querySelector('.quick-add-modal__content-info');
      if (!scrollContainer) return;

      startY = e.touches[0].clientY;
      startTime = Date.now();
      currentDeltaY = 0;
      isDragging = false;
      dragLocked = false;
    }

    function onTouchMove(e) {
      if (!scrollContainer) return;

      const currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;

      // If the user started scrolling UP inside content, lock out drag-to-dismiss for this gesture
      if (!isDragging && !dragLocked && deltaY < -10) {
        dragLocked = true;
        return;
      }
      if (dragLocked) return;

      // Only start drag-to-dismiss if content is scrolled to top and swiping DOWN
      if (scrollContainer.scrollTop > 2) {
        if (isDragging) {
          // Was dragging, but user scrolled — snap back
          snapBack();
        }
        return;
      }

      if (deltaY <= 0) {
        if (isDragging) snapBack();
        return;
      }

      // We're swiping down from the top — initiate drag
      e.preventDefault();
      isDragging = true;
      currentDeltaY = deltaY;

      const dampedY = dampen(deltaY);

      content.classList.add('is-dragging');
      content.classList.remove('is-snapping-back', 'is-closing-down');
      modal.classList.add('is-backdrop-fading');

      content.style.setProperty('transform', 'translateX(-50%) translateY(' + dampedY + 'px)', 'important');
      updateBackdrop(dampedY);
    }

    function onTouchEnd() {
      if (!isDragging) {
        dragLocked = false;
        return;
      }

      const elapsed = Date.now() - startTime;
      const velocity = elapsed > 0 ? currentDeltaY / elapsed : 0;
      const dampedY = dampen(currentDeltaY);

      if (currentDeltaY > CLOSE_THRESHOLD || (velocity > VELOCITY_THRESHOLD && currentDeltaY > 40)) {
        closeModal(dampedY);
      } else {
        snapBack();
      }

      isDragging = false;
      dragLocked = false;
    }

    function snapBack() {
      isDragging = false;
      content.classList.remove('is-dragging');
      content.classList.add('is-snapping-back');
      modal.classList.remove('is-backdrop-fading');

      content.style.removeProperty('transform');
      modal.style.removeProperty('background-color');

      function onDone() {
        content.removeEventListener('transitionend', onDone);
        content.classList.remove('is-snapping-back');
      }
      content.addEventListener('transitionend', onDone);
    }

    function closeModal(currentY) {
      content.classList.remove('is-dragging');
      content.classList.add('is-closing-down');

      var offscreen = window.innerHeight - content.getBoundingClientRect().top + 40;
      content.style.setProperty('transform', 'translateX(-50%) translateY(' + offscreen + 'px)', 'important');
      content.style.setProperty('opacity', '0', 'important');
      modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0)', 'important');

      function onDone() {
        content.removeEventListener('transitionend', onDone);
        resetVisuals();
        modal._swipeClosing = true;
        modal.hide();
      }
      content.addEventListener('transitionend', onDone);

      // Safety fallback in case transitionend doesn't fire
      setTimeout(function() {
        if (modal.hasAttribute('open')) {
          resetVisuals();
          modal._swipeClosing = true;
          modal.hide();
        }
      }, 400);
    }

    if (isMobile()) {
      modal.addEventListener('touchstart', onTouchStart, { passive: true });
      modal.addEventListener('touchmove', onTouchMove, { passive: false });
      modal.addEventListener('touchend', onTouchEnd, { passive: true });
      modal.addEventListener('touchcancel', onTouchEnd, { passive: true });
    }

    // Store references for cleanup
    modal._appleSwipeHandlers = { onTouchStart, onTouchMove, onTouchEnd };
  }

  function teardownAppleSwipe(modal) {
    if (!modal._appleSwipeActive) return;
    modal._appleSwipeActive = false;

    const h = modal._appleSwipeHandlers;
    if (h) {
      modal.removeEventListener('touchstart', h.onTouchStart);
      modal.removeEventListener('touchmove', h.onTouchMove);
      modal.removeEventListener('touchend', h.onTouchEnd);
      modal.removeEventListener('touchcancel', h.onTouchEnd);
    }
    modal._appleSwipeHandlers = null;

    // Restore original hide if it was overridden
    if (modal._originalHide) {
      modal.hide = modal._originalHide;
      modal._originalHide = null;
    }
    modal._swipeClosing = false;

    var content = modal.querySelector('.quick-add-modal__content');
    if (content) {
      content.style.removeProperty('transform');
      content.style.removeProperty('opacity');
      content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down', 'is-closing-back');
    }
    modal.style.removeProperty('background-color');
    modal.classList.remove('is-backdrop-fading');
  }

  // Track when a quick-add modal closes (for re-open detection)
  var lastQuickAddCloseTime = 0;

  // Watch for quick-add-modal[open] changes
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type !== 'attributes' || m.attributeName !== 'open') return;
      var el = m.target;
      if (el.tagName && el.tagName.toLowerCase() === 'quick-add-modal') {
        if (el.hasAttribute('open')) {
          // Detect re-open: another quick-add just closed → use scale-in animation
          var isReplace = (Date.now() - lastQuickAddCloseTime) < 800;
          if (isReplace) {
            var c = el.querySelector('.quick-add-modal__content');
            if (c) {
              c.classList.add('is-replacing');
              function onAnimEnd() {
                c.removeEventListener('animationend', onAnimEnd);
                c.classList.remove('is-replacing');
              }
              c.addEventListener('animationend', onAnimEnd);
            }
          }
          // Small delay so the content is rendered before we set up handlers
          setTimeout(function() { setupAppleSwipe(el); }, 50);
        } else {
          lastQuickAddCloseTime = Date.now();
          teardownAppleSwipe(el);
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
})();

/* ============================================================
   APPLE-STYLE SWIPE-DOWN-TO-DISMISS — SIZE CHART MODAL (MOBILE)
   Mirrors the quick-add implementation above but targets
   modal-dialog[size-chart-modal].
   ============================================================ */
(function() {
  if (typeof MutationObserver === 'undefined') return;

  var SC_CLOSE_THRESHOLD = 100;
  var SC_VELOCITY_THRESHOLD = 0.35;
  var SC_BACKDROP_BASE = 0.7;

  function isMobile() { return window.innerWidth < 750; }

  function setupSizeChartSwipe(modal) {
    if (!isMobile()) return;
    if (modal._scSwipeActive) return;
    modal._scSwipeActive = true;

    var content = modal.querySelector('.product-popup-modal__content');
    if (!content) return;

    // Insert drag handle if not present
    if (!content.querySelector('.size-chart-grab-element')) {
      var handle = document.createElement('div');
      handle.classList.add('size-chart-grab-element');
      content.insertBefore(handle, content.firstChild);
    }

    var scrollContainer = null;
    var startY = 0;
    var startTime = 0;
    var currentDeltaY = 0;
    var isDragging = false;
    var dragLocked = false;

    // Override hide() for animated close
    if (!modal._scOriginalHide) {
      modal._scOriginalHide = modal.hide.bind(modal);
      modal.hide = function(preventFocus) {
        if (!isMobile() || modal._scSwipeClosing) {
          modal._scSwipeClosing = false;
          return modal._scOriginalHide(preventFocus);
        }
        content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down');
        content.classList.add('is-closing-back');
        modal.style.setProperty('background-color', 'rgba(0,0,0,0)', 'important');

        function onDone() {
          content.removeEventListener('transitionend', onDone);
          content.classList.remove('is-closing-back');
          content.style.removeProperty('transform');
          content.style.removeProperty('opacity');
          modal.style.removeProperty('background-color');
          modal._scOriginalHide(preventFocus);
        }
        content.addEventListener('transitionend', onDone);
        setTimeout(function() {
          if (modal.hasAttribute('open')) {
            content.classList.remove('is-closing-back');
            content.style.removeProperty('transform');
            content.style.removeProperty('opacity');
            modal.style.removeProperty('background-color');
            modal._scOriginalHide(preventFocus);
          }
        }, 450);
      };
    }

    function dampen(d) {
      var h = window.innerHeight;
      return d * (1 - d / (d + h * 1.2));
    }

    function updateBackdrop(dist) {
      var progress = Math.min(dist / (window.innerHeight * 0.5), 1);
      var opacity = SC_BACKDROP_BASE * (1 - progress * 0.7);
      modal.style.setProperty('background-color', 'rgba(0,0,0,' + opacity + ')', 'important');
    }

    function resetVisuals() {
      content.style.removeProperty('transform');
      content.style.removeProperty('opacity');
      modal.style.removeProperty('background-color');
      content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down', 'is-closing-back');
      modal.classList.remove('is-backdrop-fading');
    }

    function onTouchStart(e) {
      if (!isMobile()) return;
      scrollContainer = content.querySelector('.product-popup-modal__content-info') || content;
      startY = e.touches[0].clientY;
      startTime = Date.now();
      currentDeltaY = 0;
      isDragging = false;
      dragLocked = false;
    }

    function onTouchMove(e) {
      if (!scrollContainer) return;
      var currentY = e.touches[0].clientY;
      var deltaY = currentY - startY;

      if (!isDragging && !dragLocked && deltaY < -10) {
        dragLocked = true;
        return;
      }
      if (dragLocked) return;

      // Only allow drag-to-dismiss when scrolled to top
      if (scrollContainer.scrollTop > 2) {
        if (isDragging) snapBack();
        return;
      }
      // Also check the content element itself
      if (content.scrollTop > 2) {
        if (isDragging) snapBack();
        return;
      }

      if (deltaY <= 0) {
        if (isDragging) snapBack();
        return;
      }

      e.preventDefault();
      isDragging = true;
      currentDeltaY = deltaY;

      var dampedY = dampen(deltaY);
      content.classList.add('is-dragging');
      content.classList.remove('is-snapping-back', 'is-closing-down');
      modal.classList.add('is-backdrop-fading');

      content.style.setProperty('transform', 'translateX(-50%) translateY(' + dampedY + 'px)', 'important');
      updateBackdrop(dampedY);
    }

    function onTouchEnd() {
      if (!isDragging) {
        dragLocked = false;
        return;
      }
      var elapsed = Date.now() - startTime;
      var velocity = elapsed > 0 ? currentDeltaY / elapsed : 0;
      var dampedY = dampen(currentDeltaY);

      if (currentDeltaY > SC_CLOSE_THRESHOLD || (velocity > SC_VELOCITY_THRESHOLD && currentDeltaY > 30)) {
        closeModal(dampedY);
      } else {
        snapBack();
      }
      isDragging = false;
      dragLocked = false;
    }

    function snapBack() {
      isDragging = false;
      content.classList.remove('is-dragging');
      content.classList.add('is-snapping-back');
      modal.classList.remove('is-backdrop-fading');
      content.style.removeProperty('transform');
      modal.style.removeProperty('background-color');

      function onDone() {
        content.removeEventListener('transitionend', onDone);
        content.classList.remove('is-snapping-back');
      }
      content.addEventListener('transitionend', onDone);
    }

    function closeModal() {
      content.classList.remove('is-dragging');
      content.classList.add('is-closing-down');

      var offscreen = window.innerHeight - content.getBoundingClientRect().top + 40;
      content.style.setProperty('transform', 'translateX(-50%) translateY(' + offscreen + 'px)', 'important');
      content.style.setProperty('opacity', '0', 'important');
      modal.style.setProperty('background-color', 'rgba(0,0,0,0)', 'important');

      function onDone() {
        content.removeEventListener('transitionend', onDone);
        resetVisuals();
        modal._scSwipeClosing = true;
        modal.hide();
      }
      content.addEventListener('transitionend', onDone);
      setTimeout(function() {
        if (modal.hasAttribute('open')) {
          resetVisuals();
          modal._scSwipeClosing = true;
          modal.hide();
        }
      }, 400);
    }

    modal.addEventListener('touchstart', onTouchStart, { passive: true });
    modal.addEventListener('touchmove', onTouchMove, { passive: false });
    modal.addEventListener('touchend', onTouchEnd, { passive: true });
    modal.addEventListener('touchcancel', onTouchEnd, { passive: true });
    modal._scHandlers = { onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd };
  }

  function teardownSizeChartSwipe(modal) {
    if (!modal._scSwipeActive) return;
    modal._scSwipeActive = false;

    var h = modal._scHandlers;
    if (h) {
      modal.removeEventListener('touchstart', h.onTouchStart);
      modal.removeEventListener('touchmove', h.onTouchMove);
      modal.removeEventListener('touchend', h.onTouchEnd);
      modal.removeEventListener('touchcancel', h.onTouchEnd);
    }
    modal._scHandlers = null;

    if (modal._scOriginalHide) {
      modal.hide = modal._scOriginalHide;
      modal._scOriginalHide = null;
    }
    modal._scSwipeClosing = false;

    var content = modal.querySelector('.product-popup-modal__content');
    if (content) {
      content.style.removeProperty('transform');
      content.style.removeProperty('opacity');
      content.classList.remove('is-dragging', 'is-snapping-back', 'is-closing-down', 'is-closing-back');
    }
    modal.style.removeProperty('background-color');
    modal.classList.remove('is-backdrop-fading');
  }

  // Watch for size-chart-modal[open] changes
  var scObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type !== 'attributes' || m.attributeName !== 'open') return;
      var el = m.target;
      if (el.tagName && el.tagName.toLowerCase() === 'modal-dialog' && el.hasAttribute('size-chart-modal')) {
        if (el.hasAttribute('open')) {
          setTimeout(function() { setupSizeChartSwipe(el); }, 50);
        } else {
          teardownSizeChartSwipe(el);
        }
      }
    });
  });
  scObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });

  // ESC key: close size-chart first, before any other modal handlers
  document.addEventListener('keyup', function(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    var openSizeChart = document.querySelector('modal-dialog[size-chart-modal][open]');
    if (!openSizeChart) return;
    event.stopImmediatePropagation();
    openSizeChart.hide();
  }, true);
})();

/* ============================================================
   SWIPE-TO-CLOSE — PRODUCT MEDIA MODAL (MOBILE)
   Drag down from top → modal follows finger → release >150px → closes
   Drag up from bottom (past last photo) → same
   Release below threshold → snaps back
   ============================================================ */
(function() {
  var THRESHOLD = 150;

  function resetTransform(modal) {
    modal.style.transform = '';
    modal.style.transition = '';
  }

  function initProductModalSwipe(modal) {
    var startY = 0, isDragging = false, swipeDir = null;

    // Reset transform whenever modal opens (e.g. closed by button, then reopened)
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open' && modal.hasAttribute('open')) resetTransform(modal);
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    function onTouchStart(e) {
      if (window.innerWidth >= 750) return;
      startY = e.touches[0].clientY;
      isDragging = true;
      swipeDir = null;
      modal.style.transition = 'none';
    }

    function onTouchMove(e) {
      if (!isDragging || window.innerWidth >= 750) return;
      if (!modal.hasAttribute('open')) return;

      var sc = modal.querySelector('.product-media-modal__content');
      if (!sc) return;

      var deltaY = e.touches[0].clientY - startY;

      // Lock swipe direction on first significant movement
      if (!swipeDir && Math.abs(deltaY) > 10) {
        swipeDir = deltaY > 0 ? 'down' : 'up';
      }

      var atTop = sc.scrollTop <= 0;
      var atBottom = sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 5;

      if (swipeDir === 'down' && atTop && deltaY > 0) {
        e.preventDefault();
        modal.style.transform = 'translateY(' + deltaY + 'px)';
      } else if (swipeDir === 'up' && atBottom && deltaY < 0) {
        e.preventDefault();
        modal.style.transform = 'translateY(' + deltaY + 'px)';
      }
    }

    function onTouchEnd(e) {
      if (!isDragging) return;
      isDragging = false;

      var sc = modal.querySelector('.product-media-modal__content');
      var endY = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : startY;
      var deltaY = endY - startY;

      modal.style.transition = 'transform 0.3s ease';

      var atTop = sc ? sc.scrollTop <= 0 : true;
      var atBottom = sc ? sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 5 : true;

      if (deltaY > THRESHOLD && atTop) {
        modal.style.transform = 'translateY(110%)';
        setTimeout(function() { resetTransform(modal); modal.hide(); }, 280);
      } else if (deltaY < -THRESHOLD && atBottom) {
        modal.style.transform = 'translateY(-110%)';
        setTimeout(function() { resetTransform(modal); modal.hide(); }, 280);
      } else {
        // Snap back
        modal.style.transform = 'translateY(0)';
        setTimeout(function() { resetTransform(modal); }, 300);
      }

      swipeDir = null;
    }

    modal.addEventListener('touchstart', onTouchStart, { passive: true });
    modal.addEventListener('touchmove', onTouchMove, { passive: false });
    modal.addEventListener('touchend', onTouchEnd, { passive: true });
    modal.addEventListener('touchcancel', onTouchEnd, { passive: true });
  }

  // Init for product-modal elements already in DOM (product page)
  document.querySelectorAll('product-modal').forEach(initProductModalSwipe);

  // Init for product-modal elements added dynamically (quick-add)
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.tagName.toLowerCase() === 'product-modal') {
          initProductModalSwipe(node);
        }
      });
    });
  }).observe(document.body, { childList: true });
})();

//discount from link
var urlParams = new URLSearchParams(window.location.search);
var discountCode = urlParams.get('discount');

if (discountCode) {

  // Save the discount code as a session cookie
  document.cookie = `discount_code=${discountCode}; path=/`;

  // Send GET request to "/discount/[discountcode]"
  fetch(`/discount/${discountCode}`)
  .then(function() {

    // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart. 
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {},
      }),
    });
  })
  .catch(function(error) {
    console.error('Error:', error);
  });
}